var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#FCEDE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H40C42.1875 16 44 17.8125 44 20V44C44 46.25 42.1875 48 40 48H24C21.75 48 20 46.25 20 44V20C20 17.8125 21.75 16 24 16ZM30 36C27.1875 36 25 38.25 25 41C25 41.5625 25.4375 42 26 42H38C38.5 42 39 41.5625 39 41C39 38.25 36.75 36 34 36H30ZM28 30C28 31.4375 28.75 32.75 30 33.5C31.1875 34.1875 32.75 34.1875 34 33.5C35.1875 32.75 36 31.4375 36 30C36 28.625 35.1875 27.3125 34 26.5625C32.75 25.875 31.1875 25.875 30 26.5625C28.75 27.3125 28 28.625 28 30ZM29 20C28.4375 20 28 20.5 28 21C28 21.5625 28.4375 22 29 22H35C35.5 22 36 21.5625 36 21C36 20.5 35.5 20 35 20H29Z",
    fill: "#E66E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.37320064c8ca2b94189f0822ce1a35a3.svg";
export { ForwardRef as ReactComponent };